var XPointErrorCode;
(function (XPointErrorCode) {
    XPointErrorCode[XPointErrorCode["NOT_ENOUGH_ACCURACY"] = 4000] = "NOT_ENOUGH_ACCURACY";
    XPointErrorCode[XPointErrorCode["OUT_OF_BOUNDS"] = 4001] = "OUT_OF_BOUNDS";
    XPointErrorCode[XPointErrorCode["POTENTIAL_SPOOFING"] = 4003] = "POTENTIAL_SPOOFING";
    XPointErrorCode[XPointErrorCode["TOO_CLOSE_TO_BOUNDS"] = 3000] = "TOO_CLOSE_TO_BOUNDS";
    XPointErrorCode[XPointErrorCode["SOFTWARE_OUT_OF_DATE"] = 3001] = "SOFTWARE_OUT_OF_DATE";
    XPointErrorCode[XPointErrorCode["RUNNING_ANONYMIZER"] = 3002] = "RUNNING_ANONYMIZER";
    XPointErrorCode[XPointErrorCode["REMOTE_DESKTOP_DETECTED"] = 3003] = "REMOTE_DESKTOP_DETECTED";
    XPointErrorCode[XPointErrorCode["DEVICE_TAMPERING_DETECTED"] = 3004] = "DEVICE_TAMPERING_DETECTED";
    XPointErrorCode[XPointErrorCode["PROXY_DETECTED"] = 3005] = "PROXY_DETECTED";
    XPointErrorCode[XPointErrorCode["TIME_SHIFT_DETECTED"] = 3006] = "TIME_SHIFT_DETECTED";
})(XPointErrorCode || (XPointErrorCode = {}));

export { XPointErrorCode };
